/* Produtos sugeridos no carrinho.
   Preenche todo [data-cart-recs] da página — drawer e página de carrinho.
   Carregado por snippets/cart-drawer.liquid, que existe em todas as páginas. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  if (drawer.getAttribute('data-recs-enabled') !== 'true') return;

  var LIMITE = parseInt(drawer.getAttribute('data-recs-limit'), 10) || 3;

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function fmt(c) { return money.format((c || 0) / 100); }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var ancoraAtual = null;   // product_id que gerou a lista atual
  var cacheSugestoes = [];  // resposta bruta da API

  function containers() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-recs]'));
  }

  function linha(p) {
    var v = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { v = p.variants[i]; break; }
    }
    if (!v) return '';

    var titulo = esc(p.title);
    var img = p.featured_image
      ? '<img src="' + esc(p.featured_image.replace(/(\.[^.?]*)(\?|$)/, '_120x$1$2')) +
        '" alt="" width="48" height="48" loading="lazy" class="lof-rec__img">'
      : '';

    return '' +
      '<li class="lof-rec">' +
        '<a href="' + esc(p.url) + '" class="lof-rec__thumb" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="lof-rec__info">' +
          '<a href="' + esc(p.url) + '" class="lof-rec__title">' + titulo + '</a>' +
          '<span class="lof-rec__price">' + fmt(v.price) + '</span>' +
        '</div>' +
        '<button type="button" class="lof-rec__add" data-rec-add="' + v.id + '" ' +
                'aria-label="Adicionar ' + titulo + ' ao carrinho">+</button>' +
      '</li>';
  }

  function pintar(carrinho) {
    var noCarrinho = {};
    carrinho.items.forEach(function (i) { noCarrinho[i.product_id] = true; });

    var lista = cacheSugestoes
      .filter(function (p) { return !noCarrinho[p.id] && p.available; })
      .slice(0, LIMITE);

    containers().forEach(function (box) {
      var ul = box.querySelector('[data-cart-recs-list]');
      if (!ul) return;
      if (!lista.length || !carrinho.items.length) {
        box.classList.add('hidden');
        ul.innerHTML = '';
        return;
      }
      ul.innerHTML = lista.map(linha).join('');
      box.classList.remove('hidden');
    });
  }

  function atualizar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        if (!carrinho.items.length) { pintar(carrinho); return; }

        var ancora = carrinho.items[0].product_id;
        /* Só refaz a busca se o produto-base mudou: alterar quantidade
           não precisa gerar nova requisição. */
        if (ancora === ancoraAtual && cacheSugestoes.length) { pintar(carrinho); return; }

        fetch('/recommendations/products.json?product_id=' + ancora +
              '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            ancoraAtual = ancora;
            cacheSugestoes = (d && d.products) || [];
            pintar(carrinho);
          })
          .catch(function () {});
      })
      .catch(function () {});
  }

  /* Delegado no documento porque a lista é reescrita a cada alteração do carrinho. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rec-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');

    /* Na página de carrinho o HTML vem do servidor, então recarregamos.
       No drawer basta reabrir: o theme.js re-renderiza os itens. */
    var naPagina = !!btn.closest('.lof-recs-page');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-rec-add'), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        if (naPagina) { window.location.reload(); return; }
        var toggle = document.querySelector('[data-cart-toggle]');
        if (toggle) toggle.click();
      })
      .catch(function () {})
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* O theme.js reescreve o subtotal a cada mudança: usamos como gatilho. */
  var subtotal = drawer.querySelector('[data-cart-subtotal]');
  if (window.MutationObserver && subtotal) {
    new MutationObserver(atualizar).observe(subtotal, { childList: true, characterData: true, subtree: true });
  }
  atualizar();
})();
